import React, { useCallback, useState, useEffect } from "react";
import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import axios from "axios";
import { axiosPath } from "../../../../../../../routing/helpers/router";

export default function InformationSelectUsers(props) {
  const { moduleBridgeHex, clientID, subModuleBridgeHex, values, onChange } =
    props;
  const [userList, setUserList] = useState();

  // > LOAD USER LIST
  const loadTasksUserList = useCallback(
    async () =>
      axios
        .post(
          axiosPath("api_r_user_module_correctiveActions_tasks_user_list"),
          {
            moduleBridgeHex,
            clientID,
            subModuleBridgeHex,
          }
        )
        .then(({ data }) => {
          setUserList(data?.users);
        }),
    [moduleBridgeHex, clientID, subModuleBridgeHex]
  );

  useEffect(() => {
    loadTasksUserList();
  }, []);

  return (
    <>
      <AppMultiSelect
        options={userList}
        // title={ReactDOMServer.renderToString(
        //   <Translator
        //     file="filter"
        //     name="filter.probability"
        //   />
        // )}
        title="Listado de usuarios"
        placeholder="Enviar a los usuarios..."
        icon={<AppRemixIcon icon="user" />}
        value={values.users}
        onChange={onChange}
        isMulti
        isLoading={!userList}
        hasSelectOptions
      />
    </>
  );
}
